"use client";

/**
 * 지도 위 분류 칩 — 전체 · 카페 · 맛집 · 술집.
 *
 * 거르는 값은 백엔드가 이미 아는 이름을 그대로 쓴다(classifiedPlaceTypes):
 *   카페 → cafe_desert · 맛집 → eating_house · 술집 → tavern
 * 「전체」는 거르개를 비운다(null). 백엔드는 비어 있으면 안 거른다.
 *
 * 고른 칩은 검정이다. 아래 탭의 선택 표시와 같은 말투이고,
 * 핑크는 누르는 것(버튼)에만 쓰기로 했다.
 */
const CHIPS = [
  { label: "전체", value: null },
  { label: "카페", value: "cafe_desert" },
  { label: "맛집", value: "eating_house" },
  { label: "술집", value: "tavern" },
];

const getSelected = (placeFilters) =>
  placeFilters?.category?.find((c) => c?.is_selected)?.filter_label || null;

const PlacesCategoryChips = ({ placeFilters, setPlaceFilters }) => {
  const selected = getSelected(placeFilters);

  const pick = (value) => {
    if (value === selected) return;
    setPlaceFilters?.(
      value
        ? { category: [{ filter_label: value, is_selected: true }] }
        : null
    );
  };

  return (
    <div className="pointer-events-auto flex gap-1.5 overflow-x-auto px-3 pb-1 pt-2 [scrollbar-width:none] [&::-webkit-scrollbar]{display:none}">
      {CHIPS.map((chip) => {
        const on = chip.value === selected;
        return (
          <button
            key={chip.label}
            type="button"
            onClick={() => pick(chip.value)}
            aria-pressed={on}
            className={
              "flex-none rounded-full px-3.5 py-1.5 text-[13px] font-bold shadow-sm transition active:scale-95 " +
              (on
                ? "bg-black text-white dark:bg-white dark:text-black"
                : "bg-white text-black/70 border border-black/10 dark:bg-black/70 dark:text-white/80 dark:border-white/15")
            }
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
};

export default PlacesCategoryChips;
